import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import useAddMissingTransaction from "../hooks/useAddMissingTransaction";

export default function AddMissingTransaction() {
  const { userId } = useParams();
  const navigate = useNavigate();

  const { addMissingTransaction, isLoading, error, message } =
    useAddMissingTransaction();

  const [amount, setAmount] = useState("");

  // Read from localStorage
  const token = localStorage.getItem("authToken");
  const groupID = localStorage.getItem("group_id");
  const roleID = parseInt(localStorage.getItem("role_id"), 10);

  const handleSubmit = async () => {
    // if (!amount || parseFloat(amount) <= 0) {
    //   alert("Please enter a valid amount");
    //   return;
    // }

    const res = await addMissingTransaction({
      token,
      groupID,
      roleID,
      amount: parseFloat(amount),
      userID: userId,
    });

    if (res?.success) {
      setAmount("");
      // Optional redirect back
      // navigate(`/user/${userId}/transactions`);
    }
  };

  return (
    <div className="max-w-md mx-auto mt-10 bg-white shadow p-6 rounded-lg space-y-4 border">
      <h2 className="text-xl font-semibold">Add Missing Transaction</h2>

      <div>
        <label className="block text-sm font-medium mb-1">Amount (₹)</label>
        <input
          type="number"
          className="w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring focus:ring-gray-300"
          placeholder="Enter Amount"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
        />
      </div>

      <button
        onClick={handleSubmit}
        disabled={isLoading}
        className="w-full bg-red-600 text-white py-2 rounded-lg font-medium hover:bg-red-700 disabled:bg-gray-400 transition"
      >
        {isLoading ? "Processing..." : "Add Transaction"}
      </button>

      {error && <p className="text-red-600 text-sm">{error}</p>}
      {message && <p className="text-green-600 text-sm">{message}</p>}

      <button
        onClick={() => navigate(-1)}
        className="w-full text-center py-2 rounded-lg border mt-2 hover:bg-gray-50"
      >
        Cancel
      </button>
    </div>
  );
}
